import { analyticsManager } from './analyticsManager';
import { AppEnablePayload } from './types';

export const trackAppEnabled = (payload: AppEnablePayload): void => {
  analyticsManager.track('order_assist_app_enabled', {
    ...payload,
    app_source_displayed: analyticsManager.getDatasource(),
  });
};
